import nodeDescriptions from './nodeDescriptions';

export default {
    bagIcon: 'fas fa-suitcase',
    [nodeDescriptions.reflight]: 'icon-SVG_Reflight',
    [nodeDescriptions.flightCancelled]: 'fas fa-plane-slash',
};
